import * as z from "zod";

export const unverifyUspsContractRates = {
  name: "unverifyUspsContractRates" as const,
  input: z.object({ uspsCarrierAccountIntegrationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
